module.exports = __webpack_public_path__ + "static/media/swimming.c30c20e0.svg";